/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Resources_Resources_CountInputs */

const en_admin_resources_resources_count = /** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} resource`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} resources`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count");
};

const de_admin_resources_resources_count = /** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Ressource`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Ressourcen`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count");
};

const es_admin_resources_resources_count = /** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} recurso`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} recursos`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count");
};

const fr_admin_resources_resources_count = /** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} ressource`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} ressources`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count");
};

const nl_admin_resources_resources_count = /** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} voorziening`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} voorzieningen`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count");
};

/** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */
const it_admin_resources_resources_count = en_admin_resources_resources_count;

/** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */
const pt_br2_admin_resources_resources_count = en_admin_resources_resources_count;

/** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */
const pl_admin_resources_resources_count = en_admin_resources_resources_count;

/** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */
const hu_admin_resources_resources_count = en_admin_resources_resources_count;

/** @type {(inputs: Admin_Resources_Resources_CountInputs) => LocalizedString} */
const ro_admin_resources_resources_count = en_admin_resources_resources_count;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} resource" |
* | "other" | "{count} resources" |
*
* @param {Admin_Resources_Resources_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resources_count = /** @type {((inputs: Admin_Resources_Resources_CountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resources_CountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resources_count(inputs)
	if (locale === "de") return de_admin_resources_resources_count(inputs)
	if (locale === "es") return es_admin_resources_resources_count(inputs)
	if (locale === "fr") return fr_admin_resources_resources_count(inputs)
	if (locale === "nl") return nl_admin_resources_resources_count(inputs)
	if (locale === "it") return it_admin_resources_resources_count(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resources_count(inputs)
	if (locale === "pl") return pl_admin_resources_resources_count(inputs)
	if (locale === "hu") return hu_admin_resources_resources_count(inputs)
	return ro_admin_resources_resources_count(inputs)
});
export { admin_resources_resources_count as "admin.resources.resources_count" }